import { render, staticRenderFns } from "./RootComponent.vue?vue&type=template&id=67e84664"
import script from "./RootComponent.vue?vue&type=script&lang=js"
export * from "./RootComponent.vue?vue&type=script&lang=js"
import style0 from "./RootComponent.vue?vue&type=style&index=0&id=67e84664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports